import { FC } from 'react'
import { Navigate } from 'react-router-dom'

import LatestKnowledgePage from '@/apps/latest/pages/knowledge'
import { useReleaseChannel } from '@/features/auth'
import { useAppType } from '@/shared/contexts/AppTypeContext'
import { isLegacyApp } from '@/types/appType'

// マニュアル照会は latest shell の β 機能。legacy は凍結シェルのため導線も画面も持たない。
// URL 直打ちで来た非対象ユーザーはホームへ返す (nav の gate と route の gate を一致させる)。
// setting 読込中は判定を保留する — ここで倒すと対象ユーザーまで一瞬弾かれる。
const KnowledgePage: FC = () => {
  const { appType, isLoading } = useAppType()
  const { isBeta } = useReleaseChannel()

  if (isLoading) return null
  if (isLegacyApp(appType) || !isBeta) return <Navigate to="/" replace />
  return <LatestKnowledgePage />
}

export default KnowledgePage
